import { FC } from 'react';
import { LuBadgeDollarSign } from "react-icons/lu";
import { FaRegUser, FaUserTie } from "react-icons/fa";
import { TbLetterA, TbLetterV, TbSignature } from "react-icons/tb";
import { ImManWoman } from "react-icons/im";
import NewTooltip from './NewTooltip';

interface Profile {
  id: number;
  type: string;
  verified_level: number;
}

interface ProfileBadgeProps {
  profile: Profile;
}

const ProfileBadge: FC<ProfileBadgeProps> = ({ profile }) => {
  
  const getIcon = (type: string) => {
    switch (type) {
      case 'ISSUER':
        return <FaRegUser className="text-lg" />;
      case 'RECIPIENT':
        return <LuBadgeDollarSign className="text-lg" />;
      case 'GUARANTOR-RETAIL':
        return <TbLetterV className="text-lg" />;
      case 'GUARANTOR-WHOLESALE':
        return <TbLetterA className="text-lg" />;
      case 'SIGNATORY':
        return <TbSignature className="text-lg" />;
      case 'GUARANTOR':
        return <TbLetterA className="text-lg" />;
      case 'CONSENTING_PARTY':
        return <ImManWoman className="text-lg" />;
      case 'FINANCIAL_REPRESENTATIVE':
        return <FaUserTie className="text-lg" />;
      case 'BORROWER': // Compatibilidade
        return <LuBadgeDollarSign className="text-lg" />;
      default:
        return <FaRegUser className="text-lg" />;
    }
  };

  const getColors = (level: number) => {
    const colors = {
      0: { bg: '#FEE2E2', text: '#DC2626' }, // vermelho claro
      1: { bg: '#FED7AA', text: '#EA580C' }, // laranja claro
      2: { bg: '#FEF3C7', text: '#D97706' }, // amarelo claro
      3: { bg: '#D1FAE5', text: '#059669' }, // verde claro
      4: { bg: '#DBEAFE', text: '#2563EB' }, // azul claro
      5: { bg: '#E0E7FF', text: '#4F46E5' }, // índigo claro
    };
    return colors[level as keyof typeof colors] || colors[0];
  };

  const getTooltip = (type: string, level: number) => {
    const typeNames = {
      'ISSUER': 'Emitente',
      'RECIPIENT': 'Beneficiário',
      'GUARANTOR-RETAIL': 'Avalista Varejo',
      'GUARANTOR-WHOLESALE': 'Avalista Atacado',
      'SIGNATORY': 'Signatário',
      'GUARANTOR': 'Avalista',
      'CONSENTING_PARTY': 'Anuente',
      'FINANCIAL_REPRESENTATIVE': 'Representante Financeiro',
      'BORROWER': 'Tomador', // Compatibilidade
    };
    return `${typeNames[type as keyof typeof typeNames] || type} - Nível ${level}`;
  };

  const colors = getColors(profile.verified_level);

  return (
    <NewTooltip content={getTooltip(profile.type, profile.verified_level)}>
      <div className="inline-flex items-center gap-1">
        {/* Ícone */}
        <div 
          className="p-1 rounded"
          style={{ backgroundColor: colors.bg, color: colors.text }}
        >
          {getIcon(profile.type)}
        </div>
        
      </div>
    </NewTooltip>
  );
};

export default ProfileBadge;
